var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Vuetify'),_c('approval-modal'),_c('reminder-alert'),_c('document-reader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }